<div class="group-item">
    <header (click)="openVersions()">
        <strong class="group-counter">{{related.total}}</strong>
        <core-labels-list [labels]="groupLabels"></core-labels-list>
        <span class="arrow-marker" [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}"></span>
    </header>
</div>
